import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { img } from '../assets/img/index'
import BootIcon from 'bootstrap-icons/bootstrap-icons.svg'
import { getToken, xhr } from '../utils'
const localStorage = require('local-storage')

const Sidebar = props => {
  const token = getToken()
  const [userRolesMenu, setUserRolesMenu] = useState([])
  // eslint-disable-next-line
  const [userInfo, setUserInfo] = useState({});
  /* eslint-disable */
  const profileMenuId = [1];
  const backgroundMenuId = [2];
  const inboundMenuId = [3, 4, 35, 36, 38];
  const outboundMenuId = [5, 6, 7, 8];
  const outboundFGMenuId = [9, 10, 11, 29, 30, 31, 37];
  const productionMenuId = [12,20,21,22,23,24,25];
  const planningMenuId = [26,27,28];
  const reportStockRMPMMenuId = [13];
  const masterdataMenuId = [14, 15, 19, 32, 33, 34];
  const configurationMenuId = [16, 17, 18];
  /* eslint-enable */

  const menuUsers = []
  userRolesMenu.map(item => {
    return menuUsers.push(item.menu_id)
  })

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line
  }, [])

  const fetchData = async () => {
    const userInfo = localStorage.get('user-info')
    const userRole = localStorage.get('user-role')

    if (userInfo && userRole) {
      setUserInfo(userInfo)
      setUserRolesMenu(userRole)
    } else {
      // get list inbound outstanding po
      await xhr
        .get('active', '/user-login', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(res => {
          let rolesVendor = res.data[0].roles_id
          localStorage.set('user-info', res.data[0])
          setUserInfo(res.data[0])
          xhr.get('active', `/user-roles-menu/${rolesVendor}`).then(res => {
            const data = res.data
            setUserRolesMenu(data)
            localStorage.set('user-role', data)
          })
        })
        .catch(err => {
          console.log(err)
        })
    }
  }

  const backToHome = e => {
    window.location.href = '/'
  }

  const mainMenu = data => {
    switch (data) {
      case 1:
        return (
          // profile
          <li className='nav-item' key={data}>
            <Link
              to='/profile'
              className='nav-link text-white'
              aria-current='page'
            >
              Profile
            </Link>
          </li>
        )
      case 2:
        return (
          // background data
          <li className='nav-item' key={data}>
            <Link to='/background-jobs' className='nav-link text-white'>
              Background Data
            </Link>
          </li>
        )
      case 13:
        return (
          // report stock rmpm
          <li className='nav-item' key={data}>
            <Link
              to='/production/report-stock'
              className='nav-link text-white'
              aria-current='page'
            >
              Report Stock RMPMFG
            </Link>
          </li>
        )
      default:
        break
    }
  }

  const subMenuInbound = data => {
    switch (data) {
      case 3:
        return (
          <li key={data}>
            <Link
              to='/inbound/outstanding-po'
              className='nav-link text-white ps-5'
            >
              Outstanding PO
            </Link>
          </li>
        )
      case 4:
        return (
          <li key={data}>
            <Link
              to='/inbound/report-receive'
              className='nav-link text-white ps-5'
            >
              Report Goods Receive
            </Link>
          </li>
        )
      case 38:
        return (
          <li key={data}>
            <Link
              to='/inbound/sca'
              className='nav-link text-white ps-5'
            >
              Input SCA
            </Link>
          </li>
        )
      case 35:
        return (
          <li key={data}>
            <Link
              to='/inbound/confirm-sca'
              className='nav-link text-white ps-5'
            >
              Confirm SCA
            </Link>
          </li>
        )
      case 36:
        return (
          <li key={data}>
            <Link
              to='/inbound/po-return-sto'
              className='nav-link text-white ps-5'
            >
              List PO Return / PO STO
            </Link>
          </li>
        )
      default:
        break
    }
  }

  const headMenuInbound = data => {
    return (
      <div
        className='nav-item-tab'
        data-bs-toggle='collapse'
        data-bs-target='#inbound-collapse'
        aria-expanded='false'
      >
        <Link
          to='#'
          className='nav-link text-white'
          onClick={e => e.preventDefault()}
        >
          Inbound RMPM
          <div className='icon-chev-right'>
            <svg className='bi' width='15' height='15' fill='currentColor'>
              <use xlinkHref={`${BootIcon}#chevron-right`} />
            </svg>
          </div>
        </Link>
      </div>
    )
  }

  const subMenuOutbound = data => {
    switch (data) {
      case 5:
        return (
          <li key={data}>
            <Link
              to='/outbound/memo-return'
              className='nav-link text-white ps-5'
            >
              Memo Return
            </Link>
          </li>
        )
      case 6:
        return (
          <li key={data}>
            <Link
              to='/outbound/list-confirmation-memo-return'
              className='nav-link text-white ps-5'
            >
              Memo Return Confirm.
            </Link>
          </li>
        )
      case 7:
        return (
          <li key={data}>
            <Link
              to='/outbound/outstanding-po-return'
              className='nav-link text-white ps-5'
            >
              Outstanding PO Return
            </Link>
          </li>
        )
      case 8:
        return (
          <li key={data}>
            <Link
              to='/outbound/report-return-receive'
              className='nav-link text-white ps-5'
            >
              Report Return Goods Receive
            </Link>
          </li>
        )
      default:
        break
    }
  }

  const headMenuOutbound = () => {
    return (
      <div
        className='nav-item-tab'
        data-bs-toggle='collapse'
        data-bs-target='#outbound-collapse'
        aria-expanded='false'
      >
        <Link
          to='#'
          className='nav-link text-white'
          onClick={e => e.preventDefault()}
        >
          Outbound RMPM
          <div className='icon-chev-right'>
            <svg className='bi' width='15' height='15' fill='currentColor'>
              <use xlinkHref={`${BootIcon}#chevron-right`} />
            </svg>
          </div>
        </Link>
      </div>
    )
  }

  const subMenuOutboundFg = data => {
    switch (data) {
      case 9:
        return (
          <li key={data}>
            <Link
              to='/outbound-fg/report-po-fg'
              className='nav-link text-white ps-5'
            >
              Report PO Finish Goods
            </Link>
          </li>
        )
      case 10:
        return (
          <li key={data}>
            <Link
              to='/outbound-fg/report-prod-order'
              className='nav-link text-white ps-5'
            >
              Report Production Order
            </Link>
          </li>
        )
      case 11:
        return (
          <li key={data}>
            <Link
              to='/outbound-fg/report-gr'
              className='nav-link text-white ps-5'
            >
              Report GR at DC Nabati - FG
            </Link>
          </li>
        )
      case 29:
        return (
          <li key={data}>
            <Link
              to='/outbound-fg/delivery-fg'
              className='nav-link text-white ps-5'
            >
              Outbound Delivery
            </Link>
          </li>
        )
      case 30:
        return (
          <li key={data}>
            <Link
              to='/outbound-fg/default-po-sto'
              className='nav-link text-white ps-5'
            >
              Default PO STO
            </Link>
          </li>
        )
      case 31:
        return (
          <li key={data}>
            <Link
              to='/outbound-fg/return-fg'
              className='nav-link text-white ps-5'
            >
              Return FG
            </Link>
          </li>
        )
      case 37:
        return (
          <li key={data}>
            <Link
              to='/outbound-fg/outbound-delivery-v2'
              className='nav-link text-white ps-5'
            >
              Outbound Delivery V2
            </Link>
          </li>
        )
      default:
        break
    }
  }

  const headMenuOutboundFg = () => {
    return (
      <div
        className='nav-item-tab'
        data-bs-toggle='collapse'
        data-bs-target='#outbound-fg-collapse'
        aria-expanded='false'
      >
        <Link
          to='#'
          className='nav-link text-white'
          onClick={e => e.preventDefault()}
        >
          Outbound Finish Goods
          <div className='icon-chev-right'>
            <svg className='bi' width='15' height='15' fill='currentColor'>
              <use xlinkHref={`${BootIcon}#chevron-right`} />
            </svg>
          </div>
        </Link>
      </div>
    )
  }

  const subMenuProduction = data => {
    switch (data) {
      case 12:
        return (
          <li key={data}>
            <Link
              to='/production/gr-production-order'
              className='nav-link text-white ps-5'
            >
              GR Production Order
            </Link>
          </li>
        )
      case 20:
        return (
          <li key={data}>
            <Link
              to='/production/gi-request'
              className='nav-link text-white ps-5'
            >
              GI Production Order
            </Link>
          </li>
        )
      case 21:
        // if (userInfo?.vendor_type === 'Nabati') {
        //   return (
        //     <li key={data}>
        //       <Link
        //         to='/production/gi-confirm'
        //         className='nav-link text-white ps-5'
        //       >
        //         GI Production Order Confirm
        //       </Link>
        //     </li>
        //   )
        // }
        break
      case 22:
        // if (userInfo?.vendor_type === 'Vendor') {
        //   return (
        //     <li key={data}>
        //       <Link
        //         to='/production/gi-report'
        //         className='nav-link text-white ps-5'
        //       >
        //         Report GI PrO Request
        //       </Link>
        //     </li>
        //   )
        // }
        break
      case 23:
        // if (userInfo?.vendor_type === 'Nabati') {
        //   return (
        //     <li key={data}>
        //       <Link
        //         to='/production/gi-report-emp'
        //         className='nav-link text-white ps-5'
        //       >
        //         Report GI PrO Request
        //       </Link>
        //     </li>
        //   )
        // }
        break
      case 24:
        return (
          <li key={data}>
            <Link
              to='/production/gi-cost-center'
              className='nav-link text-white ps-5'
            >
              GI to Cost Center
            </Link>
          </li>
        )
      case 25:
        return (
          <li key={data}>
            <Link
              to='/production/gi-reservation'
              className='nav-link text-white ps-5'
            >
              GI to Reservation
            </Link>
          </li>
        )
      default:
        break
    }
  }

  const headMenuProduction = () => {
    return (
      <div
        className='nav-item-tab'
        data-bs-toggle='collapse'
        data-bs-target='#production-collapse'
        aria-expanded='false'
      >
        <Link
          to='#'
          className='nav-link text-white'
          onClick={e => e.preventDefault()}
        >
          Production
          <div className='icon-chev-right'>
            <svg className='bi' width='15' height='15' fill='currentColor'>
              <use xlinkHref={`${BootIcon}#chevron-right`} />
            </svg>
          </div>
        </Link>
      </div>
    )
  }

  const subMenuMasterData = data => {
    switch (data) {
      case 14:
        return (
          <li key={data}>
            <Link to='/master-data/vendor' className='nav-link text-white ps-5'>
              Vendor
            </Link>
          </li>
        )
      case 15:
        return (
          <li key={data}>
            <Link
              to='/master-data/company'
              className='nav-link text-white ps-5'
            >
              Company
            </Link>
          </li>
        )
      case 19:
        return (
          <li key={data}>
            <Link to='/master-data/user' className='nav-link text-white ps-5'>
              User
            </Link>
          </li>
        )
      case 32:
        return (
          <li key={data}>
            <Link to='/master-data/defect' className='nav-link text-white ps-5'>
              Defect
            </Link>
          </li>
        )
      case 33:
        return (
          <li key={data}>
            <Link to='/master-data/department' className='nav-link text-white ps-5'>
              Department
            </Link>
          </li>
        )
      case 34:
        return (
          <li key={data}>
            <Link to='/master-data/default-po-return' className='nav-link text-white ps-5'>
              Default PO Return
            </Link>
          </li>
        )
      default:
        break
    }
  }

  const headMenuMasterData = () => {
    return (
      <div
        className='nav-item-tab'
        data-bs-toggle='collapse'
        data-bs-target='#masterdata-collapse'
        aria-expanded='false'
      >
        <Link
          to='#'
          className='nav-link text-white'
          onClick={e => e.preventDefault()}
        >
          Master Data
          <div className='icon-chev-right'>
            <svg className='bi' width='15' height='15' fill='currentColor'>
              <use xlinkHref={`${BootIcon}#chevron-right`} />
            </svg>
          </div>
        </Link>
      </div>
    )
  }

  const subMenuConfiguration = data => {
    switch (data) {
      case 16:
        return (
          <li key={data}>
            <Link
              to='/configuration/email'
              className='nav-link text-white ps-5'
            >
              Email
            </Link>
          </li>
        )
      case 17:
        return (
          <li key={data}>
            <Link
              to='/configuration/mapping'
              className='nav-link text-white ps-5'
            >
              Mapping
            </Link>
          </li>
        )
      case 18:
        return (
          <li key={data}>
            <Link
              to='/configuration/plant'
              className='nav-link text-white ps-5'
            >
              Plant
            </Link>
          </li>
        )
      default:
        break
    }
  }

  const headMenuConfiguration = () => {
    return (
      <div
        className='nav-item-tab'
        data-bs-toggle='collapse'
        data-bs-target='#configuration-collapse'
        aria-expanded='false'
      >
        <Link
          to='#'
          className='nav-link text-white'
          onClick={e => e.preventDefault()}
        >
          Configuration
          <div className='icon-chev-right'>
            <svg className='bi' width='15' height='15' fill='currentColor'>
              <use xlinkHref={`${BootIcon}#chevron-right`} />
            </svg>
          </div>
        </Link>
      </div>
    )
  }

  const subMenuPlanning = data => {
    switch (data) {
      case 26:
        return (
          <li key={data}>
            <Link
              to='/planning/mps'
              className='nav-link text-white ps-5'
            >
              Master Production Schedule (MPS)
            </Link>
          </li>
        )
      case 27:
        return (
          <li key={data}>
            <Link
              to="/planning/rph"
              className="nav-link text-white ps-5"
            >
              Rencana Produksi Harian (RPH)
            </Link>
          </li>
        )
      case 28:
        return (
          <li key={data}>
            <Link
              to="/planning/report-achievement"
              className="nav-link text-white ps-5"
            >
              Report Monitoring Achievement
            </Link>
          </li>
        )
      default:
        break
    }
  }

  const headMenuPlanning = () => {
    return (
      <div
        className='nav-item-tab'
        data-bs-toggle='collapse'
        data-bs-target='#planning-collapse'
        aria-expanded='false'
      >
        <Link
          to='#'
          className='nav-link text-white'
          onClick={e => e.preventDefault()}
        >
          Planning
          <div className='icon-chev-right'>
            <svg className='bi' width='15' height='15' fill='currentColor'>
              <use xlinkHref={`${BootIcon}#chevron-right`} />
            </svg>
          </div>
        </Link>
      </div>
    )
  }
  

  return (
    <div
      className='offcanvas'
      tabIndex='-1'
      id='offcanvasSidebar'
      aria-labelledby='offcanvasSidebar'
    >
      <main>
        <div
          className='d-flex flex-column flex-shrink-0 p-3 text-white bg-soft-tosca'
          style={{ 
            width: '280px', 
            height: '100vh', 
            overflowY: 'auto',
            maxHeight: '100vh'
          }}
        >
          <div className='text-center cursor-pointer' onClick={backToHome}>
            <img
              src={img.logoNabati}
              className='nabati-logo'
              alt='nabati logo'
            />
          </div>
          <br />
          <ul className='nav nav-pills flex-column mb-auto'>
            
            {/* menu super-admin */}
            {userRolesMenu.length !== 0 ? (
              userRolesMenu[0].roles_id === 'super-admin' ? (
                <>
                  <li className='nav-item'>
                    <Link
                      to='/profile'
                      className='nav-link text-white'
                      aria-current='page'
                    >
                      Profile
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link to='/background-jobs' className='nav-link text-white'>
                      Background Data
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <div
                      className='nav-item-tab'
                      data-bs-toggle='collapse'
                      data-bs-target='#inbound-collapse'
                      aria-expanded='false'
                    >
                      <Link
                        to='#'
                        className='nav-link text-white'
                        onClick={e => e.preventDefault()}
                      >
                        Inbound RMPM
                        <div className='icon-chev-right'>
                          <svg
                            className='bi'
                            width='15'
                            height='15'
                            fill='currentColor'
                          >
                            <use xlinkHref={`${BootIcon}#chevron-right`} />
                          </svg>
                        </div>
                      </Link>
                    </div>

                    <div className='collapse' id='inbound-collapse'>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/inbound/outstanding-po'
                            className='nav-link text-white ps-5'
                          >
                            Outstanding PO
                          </Link>
                        </li>
                        <li>
                          <Link
                            to='/inbound/report-receive'
                            className='nav-link text-white ps-5'
                          >
                            Report Goods Receive
                          </Link>
                        </li>
                        <li>
                          <Link
                            to='/inbound/sca'
                            className='nav-link text-white ps-5'
                          >
                            Input SCA
                          </Link>
                        </li>
                        <li>
                          <Link
                            to='/inbound/confirm-sca'
                            className='nav-link text-white ps-5'
                          >
                            Confirm SCA
                          </Link>
                        </li>
                        <li>
                          <Link
                            to='/inbound/po-return-sto'
                            className='nav-link text-white ps-5'
                          >
                            List PO Return / PO STO
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className='nav-item'>
                    <div
                      className='nav-item-tab'
                      data-bs-toggle='collapse'
                      data-bs-target='#outbound-collapse'
                      aria-expanded='false'
                    >
                      <Link
                        to='#'
                        className='nav-link text-white'
                        onClick={e => e.preventDefault()}
                      >
                        Outbound RMPM
                        <div className='icon-chev-right'>
                          <svg
                            className='bi'
                            width='15'
                            height='15'
                            fill='currentColor'
                          >
                            <use xlinkHref={`${BootIcon}#chevron-right`} />
                          </svg>
                        </div>
                      </Link>
                    </div>

                    <div className='collapse' id='outbound-collapse'>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/outbound/memo-return'
                            className='nav-link text-white ps-5'
                          >
                            Memo Return
                          </Link>
                        </li>
                        <li>
                          <Link
                            to='/outbound/list-confirmation-memo-return'
                            className='nav-link text-white ps-5'
                          >
                            Memo Return Confirm.
                          </Link>
                        </li>
                        <li>
                          <Link
                            to='/outbound/outstanding-po-return'
                            className='nav-link text-white ps-5'
                          >
                            Outstanding PO Return
                          </Link>
                        </li>
                        <li>
                          <Link
                            to='/outbound/report-return-receive'
                            className='nav-link text-white ps-5'
                          >
                            Report Return Goods Receive
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className='nav-item'>
                    <div
                      className='nav-item-tab'
                      data-bs-toggle='collapse'
                      data-bs-target='#outbound-fg-collapse'
                      aria-expanded='false'
                    >
                      <Link
                        to='#'
                        className='nav-link text-white'
                        onClick={e => e.preventDefault()}
                      >
                        Outbound Finish Goods
                        <div className='icon-chev-right'>
                          <svg
                            className='bi'
                            width='15'
                            height='15'
                            fill='currentColor'
                          >
                            <use xlinkHref={`${BootIcon}#chevron-right`} />
                          </svg>
                        </div>
                      </Link>
                    </div>

                    <div className='collapse' id='outbound-fg-collapse'>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/outbound-fg/report-po-fg'
                            className='nav-link text-white ps-5'
                          >
                            Report PO Finish Goods
                          </Link>
                        </li>
                        <li>
                          <Link
                            to='/outbound-fg/report-prod-order'
                            className='nav-link text-white ps-5'
                          >
                            Report Production Order
                          </Link>
                        </li>
                        <li>
                          <Link
                            to='/outbound-fg/report-gr'
                            className='nav-link text-white ps-5'
                          >
                            Report GR at DC Nabati - FG
                          </Link>
                        </li>
                        <li>
                          <Link
                            to='/outbound-fg/delivery-fg'
                            className='nav-link text-white ps-5'
                          >
                            Outbound Delivery
                          </Link>
                        </li>
                        <li>
                          <Link
                            to='/outbound-fg/default-po-sto'
                            className='nav-link text-white ps-5'
                          >
                            Default PO STO
                          </Link>
                        </li>
                        <li>
                          <Link
                            to='/outbound-fg/return-fg'
                            className='nav-link text-white ps-5'
                          >
                            Return FG
                          </Link>
                        </li>
                        <li>
                          <Link
                            to='/outbound-fg/outbound-delivery-v2'
                            className='nav-link text-white ps-5'
                          >
                            Outbound Delivery V2
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className='nav-item'>
                    <div
                      className='nav-item-tab'
                      data-bs-toggle='collapse'
                      data-bs-target='#production-collapse'
                      aria-expanded='false'
                    >
                      <Link
                        to='#'
                        className='nav-link text-white'
                        onClick={e => e.preventDefault()}
                      >
                        Production
                        <div className='icon-chev-right'>
                          <svg
                            className='bi'
                            width='15'
                            height='15'
                            fill='currentColor'
                          >
                            <use xlinkHref={`${BootIcon}#chevron-right`} />
                          </svg>
                        </div>
                      </Link>
                    </div>
                    <div className='collapse' id='production-collapse'>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/production/gr-production-order'
                            className='nav-link text-white ps-5'
                          >
                            GR Production Order
                          </Link>
                        </li>
                      </ul>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/production/gi-request'
                            className='nav-link text-white ps-5'
                          >
                            GI Production Order
                          </Link>
                        </li>
                      </ul>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/production/gi-cost-center'
                            className='nav-link text-white ps-5'
                          >
                            GI to Cost Center
                          </Link>
                        </li>
                      </ul>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/production/gi-reservation'
                            className='nav-link text-white ps-5'
                          >
                            GI to Reservation
                          </Link>
                        </li>
                      </ul>
                      {/* 
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/production/gi-confirm'
                            className='nav-link text-white ps-5'
                          >
                            GI Production Order Confirm
                          </Link>
                        </li>
                      </ul> 
                      <ul className="btn-toggle-nav list-unstyled fw-normal pb-1">
                        <li>
                          <Link
                            to="/production/gi-report-emp"
                            className="nav-link text-white ps-5"
                          >
                            Report GI Pro Request
                          </Link>
                        </li>
                      </ul>
                      */}
                    </div>
                  </li>
                  <li className='nav-item'>
                    <Link
                      to='/production/report-stock'
                      className='nav-link text-white'
                      aria-current='page'
                    >
                      Report Stock RMPMFG
                    </Link>
                  </li>
                  {/* PLANNING : MPS / RPH / REPORT MONITOR */}
                  <li className='nav-item'>
                    <div
                      className='nav-item-tab'
                      data-bs-toggle='collapse'
                      data-bs-target='#planning-collapse'
                      aria-expanded='false'
                    >
                      <Link
                        to='#'
                        className='nav-link text-white'
                        onClick={e => e.preventDefault()}
                      >
                        Planning
                        <div className='icon-chev-right'>
                          <svg
                            className='bi'
                            width='15'
                            height='15'
                            fill='currentColor'
                          >
                            <use xlinkHref={`${BootIcon}#chevron-right`} />
                          </svg>
                        </div>
                      </Link>
                    </div>
                    <div className='collapse' id='planning-collapse'>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/planning/mps'
                            className='nav-link text-white ps-5'
                          >
                            Master Production Schedule (MPS)
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/planning/rph"
                            className="nav-link text-white ps-5"
                          >
                            Rencana Produksi Harian (RPH)
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/planning/report-achievement"
                            className="nav-link text-white ps-5"
                          >
                            Report Monitoring Achievement
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className='nav-item'>
                    <div
                      className='nav-item-tab'
                      data-bs-toggle='collapse'
                      data-bs-target='#masterdata-collapse'
                      aria-expanded='false'
                    >
                      <Link
                        to='#'
                        className='nav-link text-white'
                        onClick={e => e.preventDefault()}
                      >
                        Master Data
                        <div className='icon-chev-right'>
                          <svg
                            className='bi'
                            width='15'
                            height='15'
                            fill='currentColor'
                          >
                            <use xlinkHref={`${BootIcon}#chevron-right`} />
                          </svg>
                        </div>
                      </Link>
                    </div>

                    <div className='collapse' id='masterdata-collapse'>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/master-data/vendor'
                            className='nav-link text-white ps-5'
                          >
                            Vendor
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className='collapse' id='masterdata-collapse'>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/master-data/company'
                            className='nav-link text-white ps-5'
                          >
                            Company
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className='collapse' id='masterdata-collapse'>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/master-data/user'
                            className='nav-link text-white ps-5'
                          >
                            User
                          </Link>
                        </li>
                      </ul>
                    </div>
                     <div className='collapse' id='masterdata-collapse'>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/master-data/defect'
                            className='nav-link text-white ps-5'
                          >
                            Defect
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className='collapse' id='masterdata-collapse'>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/master-data/department'
                            className='nav-link text-white ps-5'
                          >
                            Department
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className='collapse' id='masterdata-collapse'>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/master-data/default-po-return'
                            className='nav-link text-white ps-5'
                          >
                            Default PO Return
                          </Link>
                        </li>
                      </ul>
                    </div>

                  </li>
                  <li className='nav-item'>
                    <div
                      className='nav-item-tab'
                      data-bs-toggle='collapse'
                      data-bs-target='#configuration-collapse'
                      aria-expanded='false'
                    >
                      <Link
                        to='#'
                        className='nav-link text-white'
                        onClick={e => e.preventDefault()}
                      >
                        Configuration
                        <div className='icon-chev-right'>
                          <svg
                            className='bi'
                            width='15'
                            height='15'
                            fill='currentColor'
                          >
                            <use xlinkHref={`${BootIcon}#chevron-right`} />
                          </svg>
                        </div>
                      </Link>
                    </div>
                    <div className='collapse' id='configuration-collapse'>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/configuration/email'
                            className='nav-link text-white ps-5'
                          >
                            Email
                          </Link>
                        </li>
                      </ul>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/configuration/mapping'
                            className='nav-link text-white ps-5'
                          >
                            Mapping
                          </Link>
                        </li>
                      </ul>
                      <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                        <li>
                          <Link
                            to='/configuration/plant'
                            className='nav-link text-white ps-5'
                          >
                            Plant
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  
                </>
              ) : (
                <>
                  {/* not super admin */}
                  {/* profile - background data - report stock rmpm */}
                  {userRolesMenu.map(data => {
                    let menuId = data.menu_id
                    return mainMenu(menuId)
                  })}

                  {/* inbound rmpm */}
                  {userRolesMenu.length !== 0 ? (
                    userRolesMenu[0].roles_id === 'vendor-plant' ? (
                      <li className='nav-item'>
                        <div
                          className='nav-item-tab'
                          data-bs-toggle='collapse'
                          data-bs-target='#inbound-collapse'
                          aria-expanded='false'
                        >
                          <Link
                            to='#'
                            className='nav-link text-white'
                            onClick={e => e.preventDefault()}
                          >
                            Inbound RMPM
                            <div className='icon-chev-right'>
                              <svg
                                className='bi'
                                width='15'
                                height='15'
                                fill='currentColor'
                              >
                                <use xlinkHref={`${BootIcon}#chevron-right`} />
                              </svg>
                            </div>
                          </Link>
                        </div>

                        <div className='collapse' id='inbound-collapse'>
                          <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                            {userRolesMenu.map(data => {
                              let menuId = data.menu_id
                              return subMenuInbound(menuId)
                            })}
                          </ul>
                        </div>
                      </li>
                    ) : ( userRolesMenu[0].roles_id.includes('sub-user') !== false || menuUsers.some(val => inboundMenuId.includes(val)) ) && (
                        <li className='nav-item'>
                          {menuUsers.some(val => inboundMenuId.includes(val)) && headMenuInbound()}

                          <div className='collapse' id='inbound-collapse'>
                            <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                              {userRolesMenu.map(data => {
                                let menuId = data.menu_id
                                return subMenuInbound(menuId)
                              })}
                            </ul>
                          </div>
                        </li>
                      )
                  ) : (
                    ''
                  )}

                  {/* outbound rmpm */}
                  {userRolesMenu.length !== 0 ? (
                    userRolesMenu[0].roles_id === 'vendor-plant' ||
                    userRolesMenu[0].roles_id === 'admin' ? (
                      <li className='nav-item'>
                        <div
                          className='nav-item-tab'
                          data-bs-toggle='collapse'
                          data-bs-target='#outbound-collapse'
                          aria-expanded='false'
                        >
                          <Link
                            to='#'
                            className='nav-link text-white'
                            onClick={e => e.preventDefault()}
                          >
                            Outbound RMPM
                            <div className='icon-chev-right'>
                              <svg
                                className='bi'
                                width='15'
                                height='15'
                                fill='currentColor'
                              >
                                <use xlinkHref={`${BootIcon}#chevron-right`} />
                              </svg>
                            </div>
                          </Link>
                        </div>

                        <div className='collapse' id='outbound-collapse'>
                          <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                            {userRolesMenu.map(data => {
                              let menuId = data.menu_id
                              return subMenuOutbound(menuId)
                            })}
                          </ul>
                        </div>
                      </li>
                    ) : ( userRolesMenu[0].roles_id.includes('sub-user') || menuUsers.some(val => outboundMenuId.includes(val)) ) && (
                        <li className='nav-item'>
                          { headMenuOutbound() }

                          <div className='collapse' id='outbound-collapse'>
                            <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                              {userRolesMenu.map(data => {
                                let menuId = data.menu_id
                                return subMenuOutbound(menuId)
                              })}
                            </ul>
                          </div>
                        </li>
                      )
                  ) : (
                    ''
                  )}

                  {/* outbound finish goods */}
                  {userRolesMenu.length !== 0 ? (
                    userRolesMenu[0].roles_id === 'vendor-no-plant' ||
                    userRolesMenu[0].roles_id === 'admin' ||
                    userRolesMenu[0].roles_id === 'vendor-plant' ? (
                      <li className='nav-item'>
                        <div
                          className='nav-item-tab'
                          data-bs-toggle='collapse'
                          data-bs-target='#outbound-fg-collapse'
                          aria-expanded='false'
                        >
                          <Link
                            to='#'
                            className='nav-link text-white'
                            onClick={e => e.preventDefault()}
                          >
                            Outbound Finish Goods
                            <div className='icon-chev-right'>
                              <svg
                                className='bi'
                                width='15'
                                height='15'
                                fill='currentColor'
                              >
                                <use xlinkHref={`${BootIcon}#chevron-right`} />
                              </svg>
                            </div>
                          </Link>
                        </div>

                        <div className='collapse' id='outbound-fg-collapse'>
                          <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                            {userRolesMenu.map(data => {
                              let menuId = data.menu_id
                              return subMenuOutboundFg(menuId)
                            })}
                          </ul>
                        </div>
                      </li>
                    ) : (userRolesMenu[0].roles_id.includes('sub-user') !== false || menuUsers.some(val => outboundFGMenuId.includes(val)) ) && (
                      <li className='nav-item'>
                        {headMenuOutboundFg()}

                        <div className='collapse' id='outbound-fg-collapse'>
                          <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                            {userRolesMenu.map(data => {
                              let menuId = data.menu_id
                              return subMenuOutboundFg(menuId)
                            })}
                          </ul>
                        </div>
                      </li>
                    )
                  ) : (
                    ''
                  )}

                  {/* production */}
                  {userRolesMenu.length !== 0 ? (
                    userRolesMenu[0].roles_id === 'vendor-plant' ? (
                      <li className='nav-item'>
                        <div
                          className='nav-item-tab'
                          data-bs-toggle='collapse'
                          data-bs-target='#production-collapse'
                          aria-expanded='false'
                        >
                          <Link
                            to='#'
                            className='nav-link text-white'
                            onClick={e => e.preventDefault()}
                          >
                            Production
                            <div className='icon-chev-right'>
                              <svg
                                className='bi'
                                width='15'
                                height='15'
                                fill='currentColor'
                              >
                                <use xlinkHref={`${BootIcon}#chevron-right`} />
                              </svg>
                            </div>
                          </Link>
                        </div>
                        <div className='collapse' id='production-collapse'>
                          <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                            {userRolesMenu.map(data => {
                              let menuId = data.menu_id
                              return subMenuProduction(menuId)
                            })}
                          </ul>
                        </div>
                      </li>
                    ) : userRolesMenu[0].roles_id === 'admin' ? (
                      <li className='nav-item'>
                        <div
                          className='nav-item-tab'
                          data-bs-toggle='collapse'
                          data-bs-target='#production-collapse'
                          aria-expanded='false'
                        >
                          <Link
                            to='#'
                            className='nav-link text-white'
                            onClick={e => e.preventDefault()}
                          >
                            Production
                            <div className='icon-chev-right'>
                              <svg
                                className='bi'
                                width='15'
                                height='15'
                                fill='currentColor'
                              >
                                <use xlinkHref={`${BootIcon}#chevron-right`} />
                              </svg>
                            </div>
                          </Link>
                        </div>
                        {/* <div className='collapse' id='production-collapse'>
                          <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                            <li>
                              <Link
                                to='/production/gi-confirm'
                                className='nav-link text-white ps-5'
                              >
                                GI Production Order Confirm
                              </Link>
                            </li>
                          </ul>
                          <ul className="btn-toggle-nav list-unstyled fw-normal pb-1">
                            <li>
                              <Link
                                to="/production/gi-report-emp"
                                className="nav-link text-white ps-5"
                              >
                                Report GI PrO Request
                              </Link>
                            </li>
                          </ul>
                        </div> */}
                      </li>
                    ) : (userRolesMenu[0].roles_id.includes('sub-user') !== false || menuUsers.some(val => productionMenuId.includes(val)) ) && (
                      <li className='nav-item'>
                        { headMenuProduction() }

                        <div className='collapse' id='production-collapse'>
                          <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                            {userRolesMenu.map(data => {
                              let menuId = data.menu_id
                              return subMenuProduction(menuId)
                            })}
                          </ul>
                        </div>
                      </li>
                    )
                  ) : (
                    ''
                  )}

                  {/* planning admin */}
                  {userRolesMenu.length !== 0 ? (
                    userRolesMenu[0].roles_id === 'admin' || userRolesMenu[0].roles_id === 'vendor-plant' ? (
                      <li className='nav-item'>
                        <div
                          className='nav-item-tab'
                          data-bs-toggle='collapse'
                          data-bs-target='#planning-collapse'
                          aria-expanded='false'
                        >
                          <Link
                            to='#'
                            className='nav-link text-white'
                            onClick={e => e.preventDefault()}
                          >
                            Planning
                            <div className='icon-chev-right'>
                              <svg
                                className='bi'
                                width='15'
                                height='15'
                                fill='currentColor'
                              >
                                <use xlinkHref={`${BootIcon}#chevron-right`} />
                              </svg>
                            </div>
                          </Link>
                        </div>

                        {/* Planning 09-10-2024 */}
                        <div className='collapse' id='planning-collapse'>
                          <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                            { userRolesMenu[0].roles_id === 'admin' ? (
                              <li>
                                <Link
                                  to='/planning/mps'
                                  className='nav-link text-white ps-5'
                                >
                                  Master Production Schedule (MPS)
                                </Link>
                              </li>
                            ) : userRolesMenu[0].roles_id === 'vendor-plant' ? (
                              <>
                                <li>
                                  <Link
                                    to="/planning/rph"
                                    className="nav-link text-white ps-5"
                                  >
                                    Rencana Produksi Harian (RPH)
                                  </Link>
                                </li>
                              </>
                            ) : (
                              <></>
                            )}
                            <li>
                              <Link
                                to="/planning/report-achievement"
                                className="nav-link text-white ps-5"
                              >
                                Report Monitoring Achievement
                              </Link>
                            </li>
                          </ul>
                          
                        </div>
                      </li>
                    ) : (
                      ( menuUsers.some(val => planningMenuId.includes(val)) )  && (
                        <li className='nav-item'>
                          { headMenuPlanning() }

                          <div className='collapse' id='planning-collapse'>
                            <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                              {userRolesMenu.map(data => {
                                let menuId = data.menu_id
                                return subMenuPlanning(menuId)
                              })}
                            </ul>
                          </div>
                        </li>
                      )
                    )
                  ) : (
                    ''
                  )}

                  {/* master data */}
                  {userRolesMenu.length !== 0 ? (
                    userRolesMenu[0].roles_id === 'admin' ? (
                      <li className='nav-item'>
                        <div
                          className='nav-item-tab'
                          data-bs-toggle='collapse'
                          data-bs-target='#masterdata-collapse'
                          aria-expanded='false'
                        >
                          <Link
                            to='#'
                            className='nav-link text-white'
                            onClick={e => e.preventDefault()}
                          >
                            Master Data
                            <div className='icon-chev-right'>
                              <svg
                                className='bi'
                                width='15'
                                height='15'
                                fill='currentColor'
                              >
                                <use xlinkHref={`${BootIcon}#chevron-right`} />
                              </svg>
                            </div>
                          </Link>
                        </div>

                        <div className='collapse' id='masterdata-collapse'>
                          <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                            {userRolesMenu.map(data => {
                              let menuId = data.menu_id
                              return subMenuMasterData(menuId)
                            })}
                          </ul>
                        </div>
                      </li>
                    ) : ( userRolesMenu[0].roles_id.includes('sub-user') || menuUsers.some(val => masterdataMenuId.includes(val)) ) !== false && (
                      <li className='nav-item'>
                        { headMenuMasterData() }

                        <div className='collapse' id='masterdata-collapse'>
                          <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                            {userRolesMenu.map(data => {
                              let menuId = data.menu_id
                              return subMenuMasterData(menuId)
                            })}
                          </ul>
                        </div>
                      </li>
                    )
                  ) : (
                    ''
                  )}

                  {/* configuration */}
                  {userRolesMenu.length !== 0 ? (
                    userRolesMenu[0].roles_id === 'admin' ? (
                      <li className='nav-item'>
                        <div
                          className='nav-item-tab'
                          data-bs-toggle='collapse'
                          data-bs-target='#configuration-collapse'
                          aria-expanded='false'
                        >
                          <Link
                            to='#'
                            className='nav-link text-white'
                            onClick={e => e.preventDefault()}
                          >
                            Configuration
                            <div className='icon-chev-right'>
                              <svg
                                className='bi'
                                width='15'
                                height='15'
                                fill='currentColor'
                              >
                                <use xlinkHref={`${BootIcon}#chevron-right`} />
                              </svg>
                            </div>
                          </Link>
                        </div>

                        <div className='collapse' id='configuration-collapse'>
                          <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                            {userRolesMenu.map(data => {
                              let menuId = data.menu_id
                              return subMenuConfiguration(menuId)
                            })}
                          </ul>
                        </div>
                      </li>
                    ) : (
                      ( userRolesMenu[0].roles_id.includes('sub-user') !== false || menuUsers.some(val => configurationMenuId.includes(val)) ) && (
                        <li className='nav-item'>
                          {headMenuConfiguration()}

                          <div className='collapse' id='configuration-collapse'>
                            <ul className='btn-toggle-nav list-unstyled fw-normal pb-1'>
                              {userRolesMenu.map(data => {
                                let menuId = data.menu_id
                                return subMenuConfiguration(menuId)
                              })}
                            </ul>
                          </div>
                        </li>
                      )
                    )
                  ) : (
                    ''
                  )}
                </>
              )
            ) : (
              ''
            )}
          </ul>
        </div>
      </main>
    </div>
  )
}

export default Sidebar

// Notes of number menus:
// A. Profile (1)
// B. background data (2)
// C. inbound RMPM  > outstanding PO (3)
// 		            > report Goods Receive (4)
//                > Input SCA (38) #New Menu 22 August 2025
//                > Confirm SCA (35) #New Menu 29 August 2025
//                > List PO Return / STO (36) #New Menu 01-September-2025
// D. outbound RMPM > memo return (5)
// 		            > memo return confirm (6)
// 		            > outstanding po return (7)
// 		            > report return goods receive (8)
// E. outbound FG	> report PO finish goods (9)
// 		            > report production order (10)
// 		            > report GR at DC nabati (11)
// 		            > outbound delivery (29) #New Menu 08-July-2025
// 		            > Default PO STO (30) #New Menu 10-July-2025
// 		            > Return FG (31) #New Menu 31-July-2025
//                > outbound delivery v2 (37) #New Menu 01-July-2026
// F. production	> GR production order (12)
//                > GI production order request (20) #New Menu 08-June-22 
//                > GI Production Order Confirm (21) //not active
//                > Report GI PrO Request Vendor (22) //not active
//                > Report GI PrO Request Empl (23) //not active
//                > GI to Cost Center (24) #New Menu 08-June-22
//                > GI to Reservation (25) #New Menu 08-June-22 
// F. planning	  > Master Production Schedule (MPS) (26) #New Menu 11-04-25
//                > Rencana Produksi Harian (RPH) (27) #New Menu 11-04-25
//                > Report Monitoring Achievement (28) #New Menu 11-04-25
// G. report stock rmpm (13)
// H. master data 	> vendor (14)
// 		            > company (15)
// 		            > users SSO (19)
//                > Defect (32) #New Menu 20-Agustus-2025
//                > Department (33) #New Menu 21-Agustus-2025
//                > Default PO Return (34) #New Menu 21-Agustus-2025
// I. configuration > email (16)
// 		            > mapping (17)
// 		            > plant (18)
